import { storage } from "@resamare/functions";
import { Admin } from "@resamare/models";
import { toast } from "@resamare/ui";
import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from "axios";

export const apiClientScanette = axios.create({});

apiClientScanette.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    if (config.params?.action === "connexion") {
        return config;
    }

    const admin = storage.get<Admin>("admin");

    if (!admin) {
        window.location.replace("/auth/login");
        return config;
    }

    const newConfig: InternalAxiosRequestConfig = {
        ...config,
        params: { ...config.params, admin_id: admin.admin_id },
    };

    return newConfig;
});

apiClientScanette.interceptors.response.use(
    (response: AxiosResponse) => {
        if (response.data === "pas d'action" || response.data === "action inconnu") {
            const error = new AxiosError(
                response.data,
                undefined,
                response.config,
                response.request,
                response,
            );
            toast.error(`Un problème est survenu: ${response.data}`);
            return Promise.reject(error);
        }
        if (response.data?.status === false) {
            const message = response.data?.message || "Un problème est survenu";
            const error = new AxiosError(
                message,
                undefined,
                response.config,
                response.request,
                response,
            );
            toast.error(message);
            return Promise.reject(error);
        }
        return response;
    },
    (error) => {
        const message = error.response?.data?.message || error.message || "Un problème est survenu";
        toast.error(message);
        return Promise.reject(error);
    },
);
